export default "__VITE_ASSET__wN$erH66__"